import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.css";
import MedicationResources from "../MedicationResources";
import Disclaimer from "../components/Disclaimer";
import { procedures } from "../data/procedureData";
import TopBar from "../components/TopBar"; // ← reusable header (breadcrumb + avatar/login + white nav + modals)

const MedicalProcedures = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const procedureFromSearch = queryParams.get("treatment");

  const defaultProcedure = procedureFromSearch || Object.keys(procedures)[0];
  const [showSidebar, setShowSidebar] = useState(false);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const [selectedProcedure, setSelectedProcedure] = useState(defaultProcedure);
  const [selectedSummary, setSelectedSummary] = useState(null);
  const [showTreatmentSelector, setShowTreatmentSelector] = useState(true);

  useEffect(() => {
    if (procedureFromSearch && procedures[procedureFromSearch]) {
      setSelectedProcedure(procedureFromSearch);
    }
  }, [procedureFromSearch]);

  if (!procedures[selectedProcedure]) {
    return <h2>Error: Procedure not found.</h2>;
  }

  const { name, description, cost, insuranceCoverage, resources } = procedures[selectedProcedure];

  const handleViewSummary = (summary) => {
    setSelectedSummary(summary);
  };

  const handleCloseSummary = () => {
    setSelectedSummary(null);
  };

  return (
    <div className="page-container">
      {/* Reusable header (breadcrumb + account dropdown + white nav + modals) */}
      <TopBar breadcrumb={`Medical Procedures > ${procedures[selectedProcedure]?.name}`} />

      <div className="medications-container">
        {isMobile && showTreatmentSelector && (
          <div className="treatment-selector-overlay">
            <div className="overlay-header">
              <button className="back-button" onClick={() => setShowTreatmentSelector(false)}>← Back</button>
              <h2>Medical Procedures</h2>
            </div>
            <div className="overlay-treatments">
              {Object.keys(procedures).map((procedure) => (
                <div
                  key={procedure}
                  className={`category-card ${selectedProcedure === procedure ? "active" : ""}`}
                  onClick={() => {
                    setSelectedProcedure(procedure);
                    navigate(`/medical-procedures?treatment=${encodeURIComponent(procedure)}`);
                    setShowTreatmentSelector(false);
                  }}
                >
                  <h3>{procedures[procedure].name}</h3>
                </div>
              ))}
            </div>
          </div>
        )}

        {isMobile && !showTreatmentSelector && (
          <button className="select-treatment-button" onClick={() => setShowTreatmentSelector(true)}>
            Select a Treatment
          </button>
        )}

        <div className="medication-layout">
          <div className={`sidebar ${isMobile && showSidebar ? "open" : ""}`}>
            <h2 className="sidebar-title">Medical Procedures</h2>
            <p className="sidebar-description">Explore different procedures used for chronic pain treatment.</p>
            <div className="sidebar-blocks">
              {Object.keys(procedures).map((procedure) => (
                <div
                  key={procedure}
                  className={`category-card ${selectedProcedure === procedure ? "active" : ""}`}
                  onClick={() => {
                    setSelectedProcedure(procedure);
                    navigate(`/medical-procedures?treatment=${encodeURIComponent(procedure)}`);
                    if (isMobile) setShowSidebar(false);
                  }}
                >
                  <h3>{procedures[procedure].name}</h3>
                </div>
              ))}
            </div>
          </div>

          <div className="main-content">
            <div className="medication-info-box">
              <h2 className="medication-title">{name}</h2>
              <p className="medication-description">{description}</p>
              {cost && <p className="medication-info"><strong>Cost:</strong> {cost}</p>}
              {insuranceCoverage && <p className="medication-info"><strong>Insurance Coverage:</strong> {insuranceCoverage}</p>}
            </div>

            <div className="research-box">
              <h3 className="resources-title">Research on Procedure Outcomes</h3>
              <MedicationResources resources={resources} onViewSummary={handleViewSummary} />
            </div>
          </div>
        </div>

        {selectedSummary && (
          <div className="summary-modal">
            <div className="modal-content">
              <button className="close-button" onClick={handleCloseSummary}>×</button>
              <h3 style={{ textAlign: "left" }}>Summary</h3>
              <div className="summary-scroll">
                <p className="sidebar-description-left">{selectedSummary}</p>
              </div>
            </div>
          </div>
        )}
      </div>

      <Disclaimer />
    </div>
  );
};

export default MedicalProcedures;
